import React from 'react';
export const AbstractItemContext = React.createContext(undefined);
export const useAbstractItem = () => React.useContext(AbstractItemContext);
